import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const PHCont = styled.div((props)=>({
  display:'flex',
  flex:1,
}))

export const Cont = styled.div((props)=>({
  display:'flex',
  flex:1,
  flexDirection:'column',
}))


export const ContDetail = styled.div((props)=>({
  display:'flex',
  marginTop:'1rem',

  'div:first-child':{
    flex:1,
    display:'flex',
    justifyContent:'end',
    paddingRight:'1rem',
    fontWeight:'bold'
  },
  'div:last-child':{
    flex:2
  },

  '.fileList': {
    display: 'flex',
    flexDirection: 'column',

    button: {
      marginBottom: '5px',

      'div.fileName': {
        display: 'flex',
      }
    },

    'button:last-child': {
      marginBottom: '0px',
    }
  }

}))

export const ChatCont = styled.div((props)=>({
  display:'flex',
  flex:1,
  justifyContent:`${props.right?'flex-end':props.center?'center':'flex-start'}`,
  alignItems:'baseline',
  marginTop:'0.5rem',

  '.time':{
    fontSize:'0.5rem',
    marginLeft:'3rem'
  },
  '.msg':{
    maxWidth:'15vw',
    overflowWrap:'break-word',
  },
}))

export const ChatContY = styled.div((props)=>({
  display:'flex',
  flexDirection:'column',
  alignItems:'baseline',
  marginTop:'0.5rem',
  '.msgCont':{
    display:'flex',
    flex:1,
    alignItems:'baseline',
  },
  '.msg':{
    maxWidth:'15vw',
    overflowWrap:'break-word',
  },
  '.time':{
    fontSize:'0.5rem',
    marginLeft:'3rem'
  },
}))

export const ChatContF = styled.div((props)=>({
  display:'flex',
  flexDirection:'column',
  alignItems:'baseline',
  marginTop:'0.5rem',

  '.name':{
    fontSize:'1.2rem',
    fontWeight:'bold'
  },
  'time':{
    fontSize:'0.7rem'
  },
  '.msgCont':{
    display:'flex',
    flex:1,
    alignItems:'baseline',
    border: '1px solid rgba(34,36,38,.15)',
    borderRadius:'0.3rem',
    padding:'0.5rem 1rem',
    width:'100%'
  },
  '.msg':{
    overflowWrap:'break-word',
  },
  '.time':{
    fontSize:'0.5rem',
    marginLeft:'3rem'
  },
}))